import { createSlice } from "@reduxjs/toolkit";

const selectedBuildingDevicesSlice = createSlice({
  name: "selectedBuildingDevices",
  initialState: null,
  reducers: {
    setSelectedBuildingDevices: (state, action) => {
      return action.payload;
    },
    clearSelectedBuildingDevices: () => {
      return null;
    },
  },
});

export const { setSelectedBuildingDevices, clearSelectedBuildingDevices } =
  selectedBuildingDevicesSlice.actions;
export const selectSelectedBuildingDevices = (state) =>
  state.selectedBuildingDevices;

export default selectedBuildingDevicesSlice.reducer;
